var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageInfo24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconInfo24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Icons/pictograms/picto-ui-info-32",
    fill: "#0063FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C23.9924423,18.624284 18.624284,23.9924423 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,1.71428571 C6.31935686,1.71428571 1.71428571,6.31935686 1.71428571,12 C1.71428571,17.6806431 6.31935686,22.2857143 12,22.2857143 C17.6806431,22.2857143 22.2857143,17.6806431 22.2857143,12 C22.279573,6.32190261 17.6780974,1.72042701 12,1.71428571 Z M12.0205714,8.832 C12.8228571,8.832 13.4811429,9.49028571 13.4811429,10.2514286 L13.4811429,10.2514286 L13.4811429,18.3977143 C13.4811429,19.1794286 12.8228571,19.8171429 12.0205714,19.8171429 C11.1977143,19.8171429 10.56,19.1794286 10.56,18.3977143 L10.56,18.3977143 L10.56,10.2514286 C10.56,9.49028571 11.1977143,8.832 12.0205714,8.832 Z M12.0205714,4.57371429 C12.9874286,4.57371429 13.7485714,5.31428571 13.7485714,6.26057143 C13.7485714,7.20685714 12.9874286,7.98857143 12.0205714,7.98857143 C11.0331429,7.98857143 10.2514286,7.20685714 10.2514286,6.26057143 C10.2514286,5.31428571 11.0331429,4.57371429 12.0205714,4.57371429 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageInfo24);
export default __webpack_public_path__ + "static/media/messageInfo24.a4d43a2e957dc36518d876dc02a188c5.svg";
export { ForwardRef as ReactComponent };